/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceSettingsDto
 */
export interface PriceSettingsDto {
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsDto
     */
    priceUnitId?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsDto
     */
    listPriceFmcFactorTarget?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsDto
     */
    localLeadFxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsDto
     */
    alternativeFxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsDto
     */
    salesDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsDto
     */
    tradeContributionDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsDto
     */
    functionalDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsDto
     */
    alternativeSalesDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsDto
     */
    alternativeFunctionalDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsDto
     */
    thresholdBelowMin?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsDto
     */
    thresholdBelowMax?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsDto
     */
    thresholdPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsDto
     */
    thresholdAboveMin?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsDto
     */
    thresholdAboveMax?: number;
}

/**
 * Check if a given object implements the PriceSettingsDto interface.
 */
export function instanceOfPriceSettingsDto(value: object): value is PriceSettingsDto {
    return true;
}

export function PriceSettingsDtoFromJSON(json: any): PriceSettingsDto {
    return PriceSettingsDtoFromJSONTyped(json, false);
}

export function PriceSettingsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceSettingsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'priceUnitId': json['priceUnitId'] == null ? undefined : json['priceUnitId'],
        'listPriceFmcFactorTarget': json['listPriceFmcFactorTarget'] == null ? undefined : json['listPriceFmcFactorTarget'],
        'localLeadFxRate': json['localLeadFxRate'] == null ? undefined : json['localLeadFxRate'],
        'alternativeFxRate': json['alternativeFxRate'] == null ? undefined : json['alternativeFxRate'],
        'salesDiscount': json['salesDiscount'] == null ? undefined : json['salesDiscount'],
        'tradeContributionDiscount': json['tradeContributionDiscount'] == null ? undefined : json['tradeContributionDiscount'],
        'functionalDiscount': json['functionalDiscount'] == null ? undefined : json['functionalDiscount'],
        'alternativeSalesDiscount': json['alternativeSalesDiscount'] == null ? undefined : json['alternativeSalesDiscount'],
        'alternativeFunctionalDiscount': json['alternativeFunctionalDiscount'] == null ? undefined : json['alternativeFunctionalDiscount'],
        'thresholdBelowMin': json['thresholdBelowMin'] == null ? undefined : json['thresholdBelowMin'],
        'thresholdBelowMax': json['thresholdBelowMax'] == null ? undefined : json['thresholdBelowMax'],
        'thresholdPrice': json['thresholdPrice'] == null ? undefined : json['thresholdPrice'],
        'thresholdAboveMin': json['thresholdAboveMin'] == null ? undefined : json['thresholdAboveMin'],
        'thresholdAboveMax': json['thresholdAboveMax'] == null ? undefined : json['thresholdAboveMax'],
    };
}

export function PriceSettingsDtoToJSON(json: any): PriceSettingsDto {
    return PriceSettingsDtoToJSONTyped(json, false);
}

export function PriceSettingsDtoToJSONTyped(value?: PriceSettingsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceUnitId': value['priceUnitId'],
        'listPriceFmcFactorTarget': value['listPriceFmcFactorTarget'],
        'localLeadFxRate': value['localLeadFxRate'],
        'alternativeFxRate': value['alternativeFxRate'],
        'salesDiscount': value['salesDiscount'],
        'tradeContributionDiscount': value['tradeContributionDiscount'],
        'functionalDiscount': value['functionalDiscount'],
        'alternativeSalesDiscount': value['alternativeSalesDiscount'],
        'alternativeFunctionalDiscount': value['alternativeFunctionalDiscount'],
        'thresholdBelowMin': value['thresholdBelowMin'],
        'thresholdBelowMax': value['thresholdBelowMax'],
        'thresholdPrice': value['thresholdPrice'],
        'thresholdAboveMin': value['thresholdAboveMin'],
        'thresholdAboveMax': value['thresholdAboveMax'],
    };
}

